import axiosDepandancy from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const defaultHeaders = {
  'Content-Type': 'application/json; charset=utf-8',
  'User-Agent': 'vscode-restclient',
  'Accept-Encoding': 'gzip, deflate',
  'Content-Length': '1260',
  'Access-Control-Allow-Headers': '*'
};

const api_headers = () => ({
  ...defaultHeaders
});

const axios = axiosDepandancy.create({
    baseURL: `${API_BASE_URL}/`,
    headers: api_headers,
});

const api = {

  post: async (url, data) => {
    try {
      const response = await axios.post(API_BASE_URL + url, data);
      return response.data;
    } catch (error) {
      return error;
    }
  }

};

export default api;
